import { InputGroup } from "@chakra-ui/react";
import { useEffect } from "react";
import useGeneral from "hooks/use-general";
import Select from "react-select";
import "./multiSelect.css";

export function SearchBar(props: {
  variant?: string;
  background?: string;
  children?: JSX.Element;
  placeholder?: string;
  borderRadius?: string | number;
  [x: string]: any;
}) {
  const { variant, background, children, placeholder, borderRadius, ...rest } =
    props;
  const customStyles = {
    option: (provided: any, state: { isSelected: any }) => ({
      ...provided,
      borderBottom: "1px dotted pink",
      color: state.isSelected ? "black" : "black",
      padding: 20,
    }),
  };
  const { getData, handleStore, isFirstRender, data, store } = useGeneral();

  useEffect(() => {
    isFirstRender && getData();
  }, []);
  return (
    <InputGroup w={{ base: "100%", md: "200px", sm: "180px" }} {...rest}>
      <>
        {data.length > 0 && (
          <>
            <Select
              onChange={handleStore}
              defaultValue={store}
              name="colors"
              options={data}
              theme={(theme: { colors: any }) => ({
                ...theme,
                borderRadius: 0,
                colors: {
                  ...theme.colors,
                  text: "#6EB680",
                  font: "#6EB680",
                  primary25: "#6EB680",
                  primary: "#6EB680",
                  neutral80: "black",
                  color: "black",
                },
              })}
              styles={customStyles}
              className="custom-select"
              classNamePrefix="select"
            />
          </>
        )}
      </>
    </InputGroup>
  );
}
